import {
  all,
  call,
  delay,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import {
  CANDIDATE_CANCEL_E_APP_REQUEST,
  CHECK_AD_SUBMIT_WARNING_REQUEST,
  CHECK_DUPLICATED_PHONE_REQUEST,
  CHECK_STEP_CANDIDATE_REQUEST,
  CREATE_POST_PRESIGNED_REQUEST,
  DELASOL_CANCEL_BY_CANDIDATE_REQUEST,
  DELASOL_CLONE_E_APP_REQUEST,
  DELASOL_RE_SUBMIT_BY_RECRUITER_REQUEST,
  DELASOL_RECRUITER_CANCEL_E_APP_REQUEST,
  DELASOL_REGISTER_BY_RECRUITER_REQUEST,
  DELASOL_SAVE_BY_AOS_REQUEST,
  DELASOL_SAVE_BY_CANDIDATE_REQUEST,
  DELASOL_SAVE_BY_RECRUITER_REQUEST,
  DELASOL_UPDATE_BY_AOS_REQUEST,
  DELASOL_UPDATE_BY_APP1_REQUEST,
  DELASOL_UPDATE_BY_APP2_REQUEST,
  DELASOL_UPDATE_BY_PRE_CANDIDATE_REQUEST,
  DELASOL_UPDATE_EMAIL_BY_RECRUITER_REQUEST,
  DELASOL_VALIDATE_CANDIDATE_REQUEST,
  DOWNLOAD_BY_CANDIDATE_REQUEST,
  FLAIR_CANCEL_BY_PRE_CANDIDATE_REQUEST,
  FLAIR_GET_PRE_CANDIDATE_DETAIL_DATA,
  FLAIR_RE_SUBMIT_BY_RECRUITER_REQUEST,
  FLAIR_RECRUITER_CANCEL_E_APP_REQUEST,
  FLAIR_REGISTER_BY_RECRUITER_REQUEST,
  FLAIR_SAVE_BY_CANDIDATE_REQUEST,
  FLAIR_SAVE_BY_RECRUITER_REQUEST,
  FLAIR_UPDATE_BY_AD_REQUEST,
  FLAIR_UPDATE_BY_PRE_CANDIDATE_REQUEST,
  FLAIR_VALIDATE_CANDIDATE_REQUEST,
  FTA_CHECK_STEP_CANDIDATE_REQUEST,
  FTA_GENERATE_OTP_REQUEST,
  FTA_RELOAD_OTP_REQUEST,
  FTA_VERIFY_OTP_REQUEST,
  GENERATE_OTP_REQUEST,
  GET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  GET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  GET_ALL_AD_DATA,
  GET_ALL_AM_DATA,
  GET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  GET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  GET_ASCORE_REQUEST,
  GET_CHECK_APPLICATION_STATUS_REQUEST,
  GET_DISTRICTS_DATA,
  GET_DOC_BUFFERED_DATA,
  GET_EAPP_PROCESS_HISTORY_DATA,
  GET_EAPP_PROCESS_HISTORY_DATA_V2,
  GET_ERE_DETAIL_REQUEST,
  GET_KAPTCHA_DATA,
  GET_LIST_OF_VALUE_DATA,
  GET_LIST_OFFICE_DATA,
  GET_LIST_TRAINING_CLASS_DATA,
  GET_PRE_CANDIDATE_DETAIL_DATA,
  GET_PROVINCES_DATA,
  GET_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  GET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  GET_STATUS_DATA,
  GET_TITLE_FOR_NOUS_DATA,
  GET_WARDS_DATA,
  GET_WARDS_2_LEVEL_DATA,
  NOUS_CANDIDATE_CANCEL_E_APP_REQUEST,
  NOUS_GET_ASCORE_REQUEST,
  NOUS_GET_PRE_CANDIDATE_DETAIL_DATA,
  NOUS_RECRUITER_CANCEL_E_APP_REQUEST,
  NOUS_REGISTER_BY_RECRUITER_REQUEST,
  NOUS_SAVE_BY_RECRUITER_REQUEST,
  NOUS_UPDATE_BY_AD_REQUEST,
  NOUS_UPDATE_BY_AM_REQUEST,
  NOUS_UPDATE_BY_AOS_REQUEST,
  NOUS_UPDATE_BY_PRE_CANDIDATE_REQUEST,
  RECRUITER_CANCEL_E_APP_REQUEST,
  REGISTER_BY_RECRUITER_REQUEST,
  RELOAD_OTP_REQUEST,
  SAVE_BY_RECRUITER_REQUEST,
  SUBMIT_CHANGE_COURSE_REQUEST,
  VALIDATE_CANDIDATE_INFO_CHANGE_COURSE_REQUEST,
  UPDATE_BY_AD_REQUEST,
  UPDATE_BY_AM_REQUEST,
  UPDATE_BY_AOS_REQUEST,
  UPDATE_BY_PRE_CANDIDATE_REQUEST,
  VERIFY_OTP_REQUEST,
  FLAIR_PICK_UP_BY_AOS,
  FLAIR_UPDATE_BY_AOS_REQUEST,
  FLAIR_SAVE_BY_AOS_REQUEST,
  CLONE_BY_RECRUITER_REQUEST,
  CLONE_BY_RECRUITER_REQUEST_FTA,
  NOUS_SAVE_BY_CANDIDATE_REQUEST,
  AGENCY_SAVE_BY_CANDIDATE_REQUEST,
  CHECK_ID_NUMBER_IN_AGIS_REQUEST,
  GET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA,
  GET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA,
  GET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA,
  NOUS_UPDATE_EMAIL_BY_RECRUITER_REQUEST,
  UPDATE_EMAIL_BY_RECRUITER_REQUEST,
} from './constants';
import {
  checkDuplicatedPhoneSuccess,
  checkStepCandidateSuccess,
  createPostPresignedSuccess,
  flairSetPreCandidateDataAction,
  generateOTPSuccess,
  getAscoreSuccess,
  getCheckApplicationStatusSuccess,
  getEreDetailSuccess,
  getTrackingSuccess,
  nousGetAscoreSuccess,
  nousSetPreCandidateDataAction,
  registerByRecruiterSuccess,
  reloadOTPSuccess,
  setADFilterConfig,
  setADSearchPreCandidateCourseDataAction,
  setADSearchInfoCandidateCourseDataAction,
  setADSearchClassCandidateCourseDataAction,
  setADSearchPreCandidatePendingDataAction,
  setADSearchPreCandidateProcessedDataAction,
  setAllAdDataAction,
  setAllAmDataAction,
  setAOSFilterConfig,
  setAOSSearchPreCandidatePendingDataAction,
  setAOSSearchPreCandidateProcessedDataAction,
  setDistrictsDataAction,
  setEappProcessHistoryDataAction,
  setEAppProcessHistoryDataActionV2,
  setFilesDataAction,
  setFilterConfig,
  setKaptchaDataAction,
  setListOfficeDataAction,
  setListOfValueDataAction,
  setListTrainingClassDataAction,
  setPreCandidateDataAction,
  setProvincesDataAction,
  setSearchPreCandidatePendingDataAction,
  setSearchPreCandidateProcessedDataAction,
  setStatusDataAction,
  setTitleForNousDataAction,
  setWardsDataAction,
  updateByPreCandidateSuccess,
  verifyOTPSuccess,
} from './actions';
import {
  candidateCancelEAppService,
  checkAdSubmitWarningService,
  candidateDownloadService,
  checkApplicationStatusService,
  checkDuplicatePhoneService,
  checkStepCandidateService,
  createPostPresignedService,
  delasolCancelByCandidateService,
  delasolCloneService,
  delasolRecruiterCancelEAppService,
  delasolRegisterByRecruiterService,
  delasolResubmitByRecruiterService,
  delasolSaveByCandidateService,
  delasolSaveByRecruiterService,
  delasolSaveTemporaryByAosService,
  delasolUpdateByAosService,
  delasolUpdateByApproval1Service,
  delasolUpdateByApproval2Service,
  delasolUpdateByPreCandidateService,
  delasolUpdateEmailByRecruiterService,
  delasolValidateCandidateService,
  flairGetPreCandidateDetailService,
  flairRecruiterCancelEAppService,
  flairRegisterByRecruiterService,
  flairSaveByCandidateService,
  flairSaveByRecruiterService,
  flairValidateCandidateService,
  ftaCheckStepCandidateService,
  ftaGenerateOTPService,
  ftaReloadOTPService,
  ftaVerifyOTPService,
  generateOTPService,
  getAllAdService,
  getAllAmService,
  getAscoreService,
  getDistrictsService,
  getDocBufferedDataService,
  getEappProcessHistoryService,
  getEAppProcessHistoryV2,
  getEreDetailService,
  getListOfficeService,
  getListOfValueService,
  getListTrainingClassService,
  getPreCandidateDetailService,
  getProvincesService,
  getStatusService,
  getTitleForNousService,
  getTrackingService,
  getWardsService,
  getWards2LevelService,
  nousCandidateCancelEAppService,
  nousGetAscoreService,
  nousGetPreCandidateDetailService,
  nousRecruiterCancelEAppService,
  nousRegisterByRecruiterService,
  nousUpdateEmailByRecruiterService,
  nousSaveByRecruiterService,
  nousUpdateByAdService,
  nousUpdateByAmService,
  nousUpdateByAosService,
  nousUpdateByPreCandidateService,
  postFileService,
  recruiterCancelEAppService,
  registerByRecruiterService,
  updateEmailByRecruiterService,
  reloadOTPService,
  saveByRecruiterService,
  submitChangeCourseService,
  validateCandidateInfoChangeCourseService,
  searchPreCandidate,
  searchPreCandidateCourse,
  searchInfoCandidateCourse,
  searchClassCandidateCourse,
  updateByAdService,
  updateByAmService,
  updateByAosService,
  updateByPreCandidateService,
  verifyOTPService,
  flairUpdateByPreCandidateService,
  flairCancelByCandidateService,
  flairResubmitByRecruiterService,
  flairUpdateByAdService,
  flairPickUpByAosService,
  flairUpdateByAosService,
  flairSaveTemporaryByAosService,
  cloneAppNoService,
  cloneAppNoServiceFTA,
  agencySaveByCandidateService,
  nousSaveByCandidateService,
  checkIdNumberInAgisService,
} from '@services/eRecruitment';
import { loadingRequest, loadingSuccess } from '@stores/global/actions';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig';
import { hasValue } from '@helpers/utils/utils';
import axios from 'axios';
import { selFilesData } from './selectors';

const { VITE_API_URL } = import.meta.env;

const isContinue = (responseTracking) =>
  responseTracking?.status !== 'ERROR' &&
  responseTracking?.status !== 'SUCCESS';

export function* getSearchPreCandidatePending({ payload }) {
  try {
    yield put(loadingRequest());
    const items = yield call(searchPreCandidate, payload);

    yield put(loadingSuccess());
    if (hasValue(items) && items.status === 'SUCCESS') {
      yield all([
        put(setSearchPreCandidatePendingDataAction(items)),
        put(
          setFilterConfig({
            ...payload,
          }),
        ),
      ]);
    } else {
      GlobalModal.openOnce({
        title: 'Lỗi tìm kiếm',
        message: items?.message,
        onOk: () => {
          // Do nothing
        },
      });
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getSearchPreCandidateProcessed({ payload }) {
  try {
    yield put(loadingRequest());
    const items = yield call(searchPreCandidate, payload);
    yield put(loadingSuccess());

    if (hasValue(items) && items.status === 'SUCCESS') {
      yield all([
        put(setSearchPreCandidateProcessedDataAction(items)),
        put(
          setFilterConfig({
            ...payload,
          }),
        ),
      ]);
    } else {
      GlobalModal.openOnce({
        title: 'Lỗi tìm kiếm',
        message: items?.message,
        onOk: () => {
          // Do nothing
        },
      });
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getADSearchPreCandidatePending({ payload }) {
  try {
    yield put(loadingRequest());
    const items = yield call(searchPreCandidate, payload);

    yield put(loadingSuccess());
    if (hasValue(items) && items.status === 'SUCCESS') {
      yield all([
        put(setADSearchPreCandidatePendingDataAction(items)),
        put(
          setADFilterConfig({
            ...payload,
          }),
        ),
      ]);
    } else {
      GlobalModal.openOnce({
        title: 'Lỗi tìm kiếm',
        message: items?.message,
        onOk: () => {
          // Do nothing
        },
      });
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getADSearchPreCandidateProcessed({ payload }) {
  try {
    yield put(loadingRequest());
    const items = yield call(searchPreCandidate, payload);
    yield put(loadingSuccess());
    if (hasValue(items) && items.status === 'SUCCESS') {
      yield all([
        put(setADSearchPreCandidateProcessedDataAction(items)),
        put(
          setADFilterConfig({
            ...payload,
          }),
        ),
      ]);
    } else {
      GlobalModal.openOnce({
        title: 'Lỗi tìm kiếm',
        message: items?.message,
        onOk: () => {
          // Do nothing
        },
      });
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getADSearchPreCandidateCourse({ payload }) {
  try {
    yield put(loadingRequest());
    const items = yield call(searchPreCandidateCourse, payload);
    yield put(loadingSuccess());
    if (hasValue(items) && items.status === 'SUCCESS') {
      yield all([
        put(setADSearchPreCandidateCourseDataAction(items)),
        put(
          setADFilterConfig({
            ...payload,
          }),
        ),
      ]);
    } else {
      GlobalModal.openOnce({
        title: 'Lỗi tìm kiếm',
        message: items?.message,
        onOk: () => {
          // Do nothing
        },
      });
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getADSearchInfoCandidateCourse({ payload }) {
  try {
    // yield put(loadingRequest());
    const items = yield call(searchInfoCandidateCourse, payload);
    // yield put(loadingSuccess());
    if (hasValue(items) && items.status === 'SUCCESS') {
      yield all([
        put(setADSearchInfoCandidateCourseDataAction(items)),
        // put(
        //   setADFilterConfig({
        //     ...payload,
        //   }),
        // ),
      ]);
    } else {
      GlobalModal.openOnce({
        title: 'Lỗi tìm kiếm',
        message: items?.message,
        onOk: () => {
          // Do nothing
        },
      });
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    // GlobalModal.openOnce({
    //   title: 'Error',
    //   message: ErrorLevelConfig.SAGA.FETCH_ERROR,
    //   onOk: () => {
    //     // Do nothing
    //   },
    // });
  }
}

export function* getADSearchClassCandidateCourse({ payload }) {
  try {
    // yield put(loadingRequest());
    const items = yield call(searchClassCandidateCourse, payload);
    // yield put(loadingSuccess());
    if (hasValue(items)) {
      yield all([
        put(setADSearchClassCandidateCourseDataAction(items)),
        // put(
        //   setADFilterConfig({
        //     ...payload,
        //   }),
        // ),
      ]);
    } else {
      // GlobalModal.openOnce({
      //   title: 'Lỗi tìm kiếm',
      //   message: items?.message,
      //   onOk: () => {
      //     // Do nothing
      //   },
      // });
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    // GlobalModal.openOnce({
    //   title: 'Error',
    //   message: ErrorLevelConfig.SAGA.FETCH_ERROR,
    //   onOk: () => {
    //     // Do nothing
    //   },
    // });
  }
}

export function* getAOSSearchPreCandidatePending({ payload }) {
  try {
    yield put(loadingRequest());
    const items = yield call(searchPreCandidate, payload);

    yield put(loadingSuccess());
    if (hasValue(items) && items.status === 'SUCCESS') {
      yield all([
        put(setAOSSearchPreCandidatePendingDataAction(items)),
        put(
          setAOSFilterConfig({
            ...payload,
          }),
        ),
      ]);
    } else {
      GlobalModal.openOnce({
        title: 'Lỗi tìm kiếm',
        message: items?.message,
        onOk: () => {
          // Do nothing
        },
      });
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAOSSearchPreCandidateProcessed({ payload }) {
  try {
    yield put(loadingRequest());
    const items = yield call(searchPreCandidate, payload);
    yield put(loadingSuccess());
    if (hasValue(items) && items.status === 'SUCCESS') {
      yield all([
        put(setAOSSearchPreCandidateProcessedDataAction(items)),
        put(
          setAOSFilterConfig({
            ...payload,
          }),
        ),
      ]);
    } else {
      GlobalModal.openOnce({
        title: 'Lỗi tìm kiếm',
        message: items?.message,
        onOk: () => {
          // Do nothing
        },
      });
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getStatusSaga({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getStatusService, payload);
    yield put(loadingSuccess());

    yield put(setStatusDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAllAdSaga({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getAllAdService, payload);
    yield put(loadingSuccess());

    yield put(setAllAdDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAllAmSaga({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getAllAmService, payload);
    yield put(loadingSuccess());

    yield put(setAllAmDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    // GlobalModal.openOnce({
    //   title: 'Error',
    //   message: ErrorLevelConfig.SAGA.FETCH_ERROR,
    //   onOk: () => {
    //     // Do nothing
    //   },
    // });
  }
}

export function* getListTrainingClassSaga({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getListTrainingClassService, payload);
    yield put(loadingSuccess());

    yield put(setListTrainingClassDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getListOfValue({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getListOfValueService, payload);
    yield put(loadingSuccess());

    yield put(setListOfValueDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getProvinces({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getProvincesService, payload);
    yield put(loadingSuccess());

    yield put(setProvincesDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getDistricts({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getDistrictsService, payload);
    if (callback) callback(response);

    yield put(loadingSuccess());

    yield put(setDistrictsDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getWards({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getWardsService, payload);
    if (callback) callback(response);

    yield put(loadingSuccess());

    yield put(setWardsDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getWards2Level({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getWards2LevelService, payload);
    if (callback) callback(response);

    yield put(loadingSuccess());

    yield put(setWardsDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getListOffice({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getListOfficeService, payload);
    yield put(loadingSuccess());

    yield put(setListOfficeDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* checkDuplicatedPhone({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(checkDuplicatePhoneService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());

    yield put(checkDuplicatedPhoneSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* createPostPresigned({ payload }) {
  try {
    yield put(loadingRequest());
    const dataImg = { fileName: payload?.img?.name };
    const response = yield call(createPostPresignedService, dataImg);

    const existingdataFiles = yield select(selFilesData);

    const dataFiles = [
      ...existingdataFiles,
      {
        s3Key: response?.s3Key,
        s3Bucket: response?.s3Bucket,
        lovType: payload?.lovType,
      },
    ];

    yield put(setFilesDataAction(dataFiles));

    if (hasValue(response)) {
      const data = response?.data?.fields;
      const formData = { ...data, file: payload?.img };

      yield call(postFileService, formData);
    }
    yield put(createPostPresignedSuccess());
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* registerByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(registerByRecruiterService, payload);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(registerByRecruiterSuccess(response));
    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* updateEmailByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(updateEmailByRecruiterService, payload);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step: 'RECRUITER_UPDATE_EMAIL',
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* updateByPreCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(updateByPreCandidateService, payload);
    if (response) {
      let responseTracking;

      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step: 'CANDIDATE_SUBMIT',
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(updateByPreCandidateSuccess(response));
    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* checkStepCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(checkStepCandidateService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());

    yield put(checkStepCandidateSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* kaptchaImage({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(
      axios.get,
      `${VITE_API_URL}/captcha/kaptcha-image.do?${payload}`,
      {
        responseType: 'blob',
      },
    );
    yield put(loadingSuccess());

    yield put(setKaptchaDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* generateOtp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(generateOTPService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());

    yield put(generateOTPSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* reloadOtp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(reloadOTPService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* verifyOtp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(verifyOTPService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());

    yield put(verifyOTPSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getCheckApplicationStatus({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(checkApplicationStatusService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());

    yield put(getCheckApplicationStatusSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getEreDetail({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getEreDetailService, payload);
    if (hasValue(response) && response.status === 'SUCCESS') {
      yield put(getEreDetailSuccess(response.data));
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getPreCandidateDetail({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getPreCandidateDetailService, payload);
    if (hasValue(response) && response.status === 'SUCCESS') {
      yield put(setPreCandidateDataAction(response.data));
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({ ...err, title: ErrorLevelConfig.SAGA.FETCH_ERROR });
  }
}

export function* getEappProcessHistoryDetail({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getEappProcessHistoryService, payload);
    if (hasValue(response) && response.status === 'SUCCESS') {
      yield put(setEappProcessHistoryDataAction(response.data));
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({ ...err, title: ErrorLevelConfig.SAGA.FETCH_ERROR });
  }
}

export function* getDocBufferedData({ payload, callback }) {
  try {
    const { docId } = payload;
    if (!docId) return;

    yield put(loadingRequest());
    const response = yield call(getDocBufferedDataService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({ ...err, title: ErrorLevelConfig.SAGA.FETCH_ERROR });
  }
}

export function* candidateCancelEApp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(candidateCancelEAppService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* updateByAm({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(updateByAmService, dataUpdate);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* submitChangeCourse({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(submitChangeCourseService, payload);

    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* validateCandidateInfoChangeCourse({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(
      validateCandidateInfoChangeCourseService,
      payload,
    );

    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* saveByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(saveByRecruiterService, payload);

    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* cloneAppNo({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(cloneAppNoService, payload);
    if (hasValue(response) && response.status === 'SUCCESS') {
      yield put(setPreCandidateDataAction(response.data));
    } else if (hasValue(response) && response.status === 'ERROR') {
      GlobalModal.openOnce({
        title: 'Error',
        message: response.message,
        onOk: () => {
          // Do nothing
        },
      });
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* cloneAppNoFTA({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(cloneAppNoServiceFTA, payload);
    if (hasValue(response) && response.status === 'SUCCESS') {
      yield put(setPreCandidateDataAction(response.data));
    } else if (hasValue(response) && response.status === 'ERROR') {
      GlobalModal.openOnce({
        title: 'Error',
        message: response.message,
        onOk: () => {
          // Do nothing
        },
      });
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* recruiterCancelEApp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(recruiterCancelEAppService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* downloadByCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(candidateDownloadService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAscore({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getAscoreService, payload);
    yield put(loadingSuccess());
    yield put(getAscoreSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* updateByAd({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(updateByAdService, dataUpdate);
    if (response) {
      let responseTracking;
      yield delay(1000);
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* updateByAos({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(updateByAosService, dataUpdate);
    if (response) {
      let responseTracking;
      yield delay(1000);
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getTitleForNous({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getTitleForNousService, payload);
    yield put(loadingSuccess());

    yield put(setTitleForNousDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

// Nous

export function* nousRegisterByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(nousRegisterByRecruiterService, payload);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* nousUpdateEmailByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(nousUpdateEmailByRecruiterService, payload);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step: 'RECRUITER_UPDATE_EMAIL',
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* nousSaveByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(nousSaveByRecruiterService, payload);

    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* nousRecruiterCancelEApp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(nousRecruiterCancelEAppService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* nousUpdateByPreCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(nousUpdateByPreCandidateService, payload);
    if (response) {
      let responseTracking;

      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step: 'CANDIDATE_SUBMIT',
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* nousCandidateCancelEApp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(nousCandidateCancelEAppService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* nousGetPreCandidateDetail({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(nousGetPreCandidateDetailService, payload);
    if (hasValue(response) && response.status === 'SUCCESS') {
      yield put(nousSetPreCandidateDataAction(response.data));
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({ ...err, title: ErrorLevelConfig.SAGA.FETCH_ERROR });
  }
}

export function* ftaCheckStepCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(ftaCheckStepCandidateService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* ftaGenerateOtp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(ftaGenerateOTPService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());

    yield put(generateOTPSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* ftaReloadOtp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(ftaReloadOTPService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* ftaVerifyOtp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(ftaVerifyOTPService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* nousUpdateByAm({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(nousUpdateByAmService, dataUpdate);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* nousGetAscore({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(nousGetAscoreService, payload);
    yield put(loadingSuccess());
    yield put(nousGetAscoreSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* nousUpdateByAd({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(nousUpdateByAdService, dataUpdate);
    if (response) {
      let responseTracking;
      yield delay(1000);
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* nousUpdateByAos({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(nousUpdateByAosService, dataUpdate);
    if (response) {
      let responseTracking;
      yield delay(1000);
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

// FLair
export function* flairValidateCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(flairValidateCandidateService, payload);
    if (response) {
      yield put(loadingSuccess());
      callback(response);
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* flairSaveByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(flairSaveByRecruiterService, payload);

    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* flairGetPreCandidateDetail({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(flairGetPreCandidateDetailService, payload);
    if (hasValue(response) && response.status === 'SUCCESS') {
      yield put(flairSetPreCandidateDataAction(response.data));
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({ ...err, title: ErrorLevelConfig.SAGA.FETCH_ERROR });
  }
}

export function* flairRecruiterCancelEApp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(flairRecruiterCancelEAppService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* flairRegisterByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(flairRegisterByRecruiterService, payload);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* flairSaveByCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(flairSaveByCandidateService, payload);

    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* flairUpdateByPreCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(flairUpdateByPreCandidateService, payload);
    if (response) {
      let responseTracking;

      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step: 'CANDIDATE_SUBMIT',
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* flairCandidateCancelEApp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(flairCancelByCandidateService, payload);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step: 'CANDIDATE_SUBMIT',
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* flairUpdateByAd({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(flairUpdateByAdService, dataUpdate);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* flairResubmitByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(flairResubmitByRecruiterService, payload);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* flairPickUpEAppByAos({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(flairPickUpByAosService, {
      id: payload?.candidateId,
    });
    if (response) {
      if (callback) callback(response);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* flairSaveByAos({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(flairSaveTemporaryByAosService, dataUpdate);
    if (response) {
      if (callback) callback(response);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* flairUpdateByAos({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(flairUpdateByAosService, dataUpdate);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* checkIdNumberInAgis({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(checkIdNumberInAgisService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* checkAdSubmitWarning({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(checkAdSubmitWarningService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

// Delasol
export function* delasolRegisterByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(delasolRegisterByRecruiterService, payload);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolSaveByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(delasolSaveByRecruiterService, payload);

    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolRecruiterCancelEApp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(delasolRecruiterCancelEAppService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

// Save by Candidate Agency and Nous
export function* agencySaveByCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(agencySaveByCandidateService, payload);

    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolUpdateEmailByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(delasolUpdateEmailByRecruiterService, payload);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step: 'RECRUITER_UPDATE_EMAIL',
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolClone({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(delasolCloneService, payload);

    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* nousSaveByCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(nousSaveByCandidateService, payload);

    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolSaveByCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(delasolSaveByCandidateService, payload);

    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolValidateCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(delasolValidateCandidateService, payload);
    if (response) {
      yield put(loadingSuccess());
      callback(response);
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolCandidateCancelEApp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(delasolCancelByCandidateService, payload);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step: 'CANDIDATE_SUBMIT',
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolUpdateByApproval1({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(delasolUpdateByApproval1Service, dataUpdate);
    if (response) {
      yield delay(1000);
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolResubmitByRecruiter({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(delasolResubmitByRecruiterService, payload);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolUpdateByPreCandidate({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(delasolUpdateByPreCandidateService, payload);
    if (response) {
      let responseTracking;
      yield delay(2000);
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step: 'CANDIDATE_SUBMIT',
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }

    yield put(getTrackingSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolUpdateByApproval2({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(delasolUpdateByApproval2Service, dataUpdate);
    if (response) {
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolSaveByAos({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(delasolSaveTemporaryByAosService, dataUpdate);
    if (response) {
      if (callback) callback(response);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* delasolUpdateByAos({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const dataUpdate = { id: payload?.id, data: payload?.data };
    const step = payload?.step;
    const response = yield call(delasolUpdateByAosService, dataUpdate);
    if (response) {
      yield delay(1000);
      let responseTracking;
      do {
        responseTracking = yield call(getTrackingService, {
          id: response?.id,
          step,
        });
        if (isContinue(responseTracking)) {
          yield delay(1000);
        }
      } while (isContinue(responseTracking));
      if (callback) callback(responseTracking);
      yield put(loadingSuccess());
    }
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getEAppProcessHistoryDetailV2({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getEAppProcessHistoryV2, payload);
    if (hasValue(response) && response.status === 'SUCCESS') {
      yield put(setEAppProcessHistoryDataActionV2(response.data));
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({ ...err, title: ErrorLevelConfig.SAGA.FETCH_ERROR });
  }
}

export default function* eRecruitmentSaga() {
  yield takeLatest(
    GET_SEARCH_PRE_CANDIDATE_PENDING_DATA,
    getSearchPreCandidatePending,
  );
  yield takeLatest(
    GET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
    getSearchPreCandidateProcessed,
  );
  yield takeLatest(
    GET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA,
    getADSearchPreCandidatePending,
  );
  yield takeLatest(
    GET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
    getADSearchPreCandidateProcessed,
  );

  yield takeLatest(
    GET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA,
    getADSearchPreCandidateCourse,
  );

  yield takeLatest(
    GET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA,
    getADSearchInfoCandidateCourse,
  );

  yield takeLatest(
    GET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA,
    getADSearchClassCandidateCourse,
  );

  yield takeLatest(
    GET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA,
    getAOSSearchPreCandidatePending,
  );
  yield takeLatest(
    GET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
    getAOSSearchPreCandidateProcessed,
  );
  yield takeLatest(GET_STATUS_DATA, getStatusSaga);
  yield takeLatest(GET_ALL_AD_DATA, getAllAdSaga);
  yield takeLatest(GET_ALL_AM_DATA, getAllAmSaga);
  yield takeLatest(GET_LIST_TRAINING_CLASS_DATA, getListTrainingClassSaga);
  yield takeLatest(GET_LIST_OF_VALUE_DATA, getListOfValue);
  yield takeLatest(GET_PROVINCES_DATA, getProvinces);
  yield takeEvery(GET_DISTRICTS_DATA, getDistricts);
  yield takeEvery(GET_WARDS_DATA, getWards);
  yield takeEvery(GET_WARDS_2_LEVEL_DATA, getWards2Level);
  yield takeLatest(GET_LIST_OFFICE_DATA, getListOffice);
  yield takeEvery(REGISTER_BY_RECRUITER_REQUEST, registerByRecruiter);
  yield takeEvery(UPDATE_EMAIL_BY_RECRUITER_REQUEST, updateEmailByRecruiter);
  yield takeLatest(CHECK_DUPLICATED_PHONE_REQUEST, checkDuplicatedPhone);
  yield takeEvery(CREATE_POST_PRESIGNED_REQUEST, createPostPresigned);
  yield takeEvery(UPDATE_BY_PRE_CANDIDATE_REQUEST, updateByPreCandidate);
  yield takeLatest(CHECK_STEP_CANDIDATE_REQUEST, checkStepCandidate);
  yield takeLatest(GET_KAPTCHA_DATA, kaptchaImage);
  yield takeLatest(GENERATE_OTP_REQUEST, generateOtp);
  yield takeLatest(RELOAD_OTP_REQUEST, reloadOtp);
  yield takeLatest(VERIFY_OTP_REQUEST, verifyOtp);
  yield takeLatest(
    GET_CHECK_APPLICATION_STATUS_REQUEST,
    getCheckApplicationStatus,
  );
  yield takeEvery(GET_ERE_DETAIL_REQUEST, getEreDetail);
  yield takeEvery(GET_PRE_CANDIDATE_DETAIL_DATA, getPreCandidateDetail);
  yield takeLatest(GET_EAPP_PROCESS_HISTORY_DATA, getEappProcessHistoryDetail);
  yield takeEvery(GET_DOC_BUFFERED_DATA, getDocBufferedData);
  yield takeLatest(CANDIDATE_CANCEL_E_APP_REQUEST, candidateCancelEApp);
  yield takeLatest(UPDATE_BY_AM_REQUEST, updateByAm);
  yield takeEvery(SAVE_BY_RECRUITER_REQUEST, saveByRecruiter);
  yield takeEvery(SUBMIT_CHANGE_COURSE_REQUEST, submitChangeCourse);
  yield takeEvery(
    VALIDATE_CANDIDATE_INFO_CHANGE_COURSE_REQUEST,
    validateCandidateInfoChangeCourse,
  );
  yield takeEvery(CLONE_BY_RECRUITER_REQUEST, cloneAppNo);
  yield takeEvery(CLONE_BY_RECRUITER_REQUEST_FTA, cloneAppNoFTA);
  yield takeLatest(RECRUITER_CANCEL_E_APP_REQUEST, recruiterCancelEApp);
  yield takeLatest(DOWNLOAD_BY_CANDIDATE_REQUEST, downloadByCandidate);
  yield takeLatest(GET_ASCORE_REQUEST, getAscore);
  yield takeLatest(UPDATE_BY_AD_REQUEST, updateByAd);
  yield takeLatest(UPDATE_BY_AOS_REQUEST, updateByAos);
  // Nous
  yield takeLatest(GET_TITLE_FOR_NOUS_DATA, getTitleForNous);
  yield takeEvery(NOUS_REGISTER_BY_RECRUITER_REQUEST, nousRegisterByRecruiter);
  yield takeEvery(
    NOUS_UPDATE_EMAIL_BY_RECRUITER_REQUEST,
    nousUpdateEmailByRecruiter,
  );
  yield takeEvery(NOUS_SAVE_BY_RECRUITER_REQUEST, nousSaveByRecruiter);
  yield takeLatest(
    NOUS_RECRUITER_CANCEL_E_APP_REQUEST,
    nousRecruiterCancelEApp,
  );
  yield takeEvery(
    NOUS_UPDATE_BY_PRE_CANDIDATE_REQUEST,
    nousUpdateByPreCandidate,
  );
  yield takeLatest(
    NOUS_CANDIDATE_CANCEL_E_APP_REQUEST,
    nousCandidateCancelEApp,
  );
  yield takeEvery(
    NOUS_GET_PRE_CANDIDATE_DETAIL_DATA,
    nousGetPreCandidateDetail,
  );
  yield takeLatest(FTA_CHECK_STEP_CANDIDATE_REQUEST, ftaCheckStepCandidate);
  yield takeLatest(FTA_GENERATE_OTP_REQUEST, ftaGenerateOtp);
  yield takeLatest(FTA_RELOAD_OTP_REQUEST, ftaReloadOtp);
  yield takeLatest(FTA_VERIFY_OTP_REQUEST, ftaVerifyOtp);
  yield takeLatest(NOUS_UPDATE_BY_AM_REQUEST, nousUpdateByAm);
  yield takeLatest(NOUS_GET_ASCORE_REQUEST, nousGetAscore);
  yield takeLatest(NOUS_UPDATE_BY_AD_REQUEST, nousUpdateByAd);
  yield takeLatest(NOUS_UPDATE_BY_AOS_REQUEST, nousUpdateByAos);

  // Flair
  yield takeEvery(FLAIR_VALIDATE_CANDIDATE_REQUEST, flairValidateCandidate);
  yield takeEvery(FLAIR_SAVE_BY_RECRUITER_REQUEST, flairSaveByRecruiter);
  yield takeEvery(
    FLAIR_GET_PRE_CANDIDATE_DETAIL_DATA,
    flairGetPreCandidateDetail,
  );
  yield takeEvery(
    FLAIR_RECRUITER_CANCEL_E_APP_REQUEST,
    flairRecruiterCancelEApp,
  );
  yield takeEvery(
    FLAIR_REGISTER_BY_RECRUITER_REQUEST,
    flairRegisterByRecruiter,
  );
  yield takeEvery(FLAIR_SAVE_BY_CANDIDATE_REQUEST, flairSaveByCandidate);
  yield takeEvery(
    FLAIR_UPDATE_BY_PRE_CANDIDATE_REQUEST,
    flairUpdateByPreCandidate,
  );
  yield takeLatest(FLAIR_UPDATE_BY_AD_REQUEST, flairUpdateByAd);

  yield takeEvery(
    FLAIR_CANCEL_BY_PRE_CANDIDATE_REQUEST,
    flairCandidateCancelEApp,
  );
  yield takeEvery(
    FLAIR_RE_SUBMIT_BY_RECRUITER_REQUEST,
    flairResubmitByRecruiter,
  );
  yield takeLatest(FLAIR_PICK_UP_BY_AOS, flairPickUpEAppByAos);
  yield takeLatest(FLAIR_UPDATE_BY_AOS_REQUEST, flairUpdateByAos);
  yield takeLatest(FLAIR_SAVE_BY_AOS_REQUEST, flairSaveByAos);

  // Delasol
  yield takeEvery(DELASOL_SAVE_BY_RECRUITER_REQUEST, delasolSaveByRecruiter);
  yield takeEvery(
    DELASOL_REGISTER_BY_RECRUITER_REQUEST,
    delasolRegisterByRecruiter,
  );
  yield takeEvery(
    DELASOL_RECRUITER_CANCEL_E_APP_REQUEST,
    delasolRecruiterCancelEApp,
  );
  yield takeEvery(
    DELASOL_UPDATE_EMAIL_BY_RECRUITER_REQUEST,
    delasolUpdateEmailByRecruiter,
  );
  yield takeEvery(DELASOL_CLONE_E_APP_REQUEST, delasolClone);

  // Save by Candidate Agency and Nous
  yield takeLatest(AGENCY_SAVE_BY_CANDIDATE_REQUEST, agencySaveByCandidate);
  yield takeLatest(NOUS_SAVE_BY_CANDIDATE_REQUEST, nousSaveByCandidate);
  yield takeLatest(CHECK_ID_NUMBER_IN_AGIS_REQUEST, checkIdNumberInAgis);
  yield takeLatest(CHECK_AD_SUBMIT_WARNING_REQUEST, checkAdSubmitWarning);

  yield takeEvery(DELASOL_SAVE_BY_CANDIDATE_REQUEST, delasolSaveByCandidate);
  yield takeEvery(DELASOL_VALIDATE_CANDIDATE_REQUEST, delasolValidateCandidate);
  yield takeEvery(
    DELASOL_CANCEL_BY_CANDIDATE_REQUEST,
    delasolCandidateCancelEApp,
  );
  yield takeEvery(
    DELASOL_RE_SUBMIT_BY_RECRUITER_REQUEST,
    delasolResubmitByRecruiter,
  );
  yield takeEvery(
    DELASOL_UPDATE_BY_PRE_CANDIDATE_REQUEST,
    delasolUpdateByPreCandidate,
  );
  yield takeLatest(DELASOL_UPDATE_BY_APP1_REQUEST, delasolUpdateByApproval1);
  yield takeLatest(DELASOL_UPDATE_BY_APP2_REQUEST, delasolUpdateByApproval2);
  yield takeLatest(DELASOL_UPDATE_BY_AOS_REQUEST, delasolUpdateByAos);
  yield takeLatest(DELASOL_SAVE_BY_AOS_REQUEST, delasolSaveByAos);
  yield takeLatest(
    GET_EAPP_PROCESS_HISTORY_DATA_V2,
    getEAppProcessHistoryDetailV2,
  );
}
